<template>
  <el-header v-if="$store.state.user" class="nav-container">
    <div class="all" v-if="level3">
      <el-menu
        mode="horizontal"
        background-color="#0e0625"
        text-color="#fff"
        active-text-color="#d40c41"
        router
      >
        <el-menu-item index="/">
          <img id="logo" src="@/assets/images/logo.svg" />
        </el-menu-item>
        <el-menu-item index="/">Home</el-menu-item>
        <el-menu-item index="/user">
          Users
        </el-menu-item>
<!--        <el-menu-item index="/track">
          Tracks
        </el-menu-item>-->
        <el-menu-item index="/new-releases">
          Music
        </el-menu-item>
        <el-menu-item index="/brands"> Brands </el-menu-item>
        <el-menu-item index="/newsletter">
          Newsletter
        </el-menu-item>
<!--        <el-submenu index="/subscription-catalogues">
          <template slot="title">
            Subscription Catalogues
          </template>
          <el-menu-item index="/subscription-catalogues/user">User</el-menu-item>
          <el-menu-item index="/subscription-catalogues/library-share">
            Library Share
          </el-menu-item>
        </el-submenu>-->
        <el-menu-item index="/reports">Reports</el-menu-item>
        <el-submenu index="/import">
          <template slot="title">
            Import
          </template>
          <el-menu-item index="/import/user">User</el-menu-item>
          <el-menu-item index="/import/admin">Admin</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/vidcents">VidCents</el-menu-item> -->
        <el-submenu index="/vidcents">
          <template slot="title">
            Campaigns
          </template>
          <el-menu-item index="/vidcents/bands">Bands</el-menu-item>
          <el-menu-item index="/vidcents/manage">Manage</el-menu-item>
          <el-menu-item index="/vidcents/transaction-history">
            Transaction History
          </el-menu-item>
          <el-menu-item index="/vidcents/paypal">
            PayPal
          </el-menu-item>
          <el-menu-item index="/vidcents/video-tracks-scan">
            Video Tracks Scan
          </el-menu-item>
        </el-submenu>
        <el-submenu index="/challenges">
          <template slot="title">
            Challenges
          </template>
          <el-menu-item index="/challenges/tracks" @click="reloadPage">Tracks</el-menu-item>
          <el-menu-item index="/challenges/brands" @click="reloadPage">Brands</el-menu-item>
        </el-submenu>
        <el-submenu index="/cms">
          <template slot="title">
            CMS
          </template>
          <el-menu-item index="/cms/affiliate">Affiliate</el-menu-item>
          <el-menu-item index="/cms/pre-approved"
          >Pre-approved channels
          </el-menu-item
          >
          <el-menu-item index="/cms/blog">Blog</el-menu-item>
          <el-menu-item index="/cms/blog-author">Blog Author</el-menu-item>
          <el-submenu index="/cms/carousel">
            <template slot="title">
              Carousel
            </template>
            <el-menu-item index="/cms/carousel/campaign-highlight"
            >Campaign Highlight
            </el-menu-item
            >
            <el-menu-item index="/cms/carousel/community">Community</el-menu-item>
            <el-menu-item index="/cms/carousel/new-releases"
            >Music
            </el-menu-item
            >
            <el-menu-item index="/cms/carousel/opportunities"
            >Opportunities
            </el-menu-item
            >
          </el-submenu>

          <el-submenu>
            <template slot="title">
              Legal pages
            </template>
            <el-menu-item index="/cms/terms">Terms & Conditions</el-menu-item>
            <el-menu-item index="/cms/legal/privacy-policy">Privacy Policy</el-menu-item>
            <el-menu-item index="/cms/legal/cookie-policy">Cookie Policy</el-menu-item>
            <el-menu-item index="/cms/legal/eula">EULA</el-menu-item>
          </el-submenu>
          <el-menu-item index="/cms/contracts">Contracts</el-menu-item>
          <el-menu-item index="/cms/faq">FAQ</el-menu-item>
          <el-menu-item index="/cms/file-manager">File Manager</el-menu-item>
          <el-menu-item index="/cms/testimonial">Testimonial</el-menu-item>
          <el-submenu index="/cms/youtube">
            <template slot="title">
              Youtube Content ID
            </template>
            <!--<el-menu-item index="/cms/youtube/assets">Assets</el-menu-item>-->
            <el-menu-item index="/cms/youtube/claims/removal"
            >Claims for removal
            </el-menu-item
            >
            <el-menu-item index="/cms/youtube/claims">Claims</el-menu-item>
            <el-menu-item index="/cms/youtube/licensing">Licensing</el-menu-item>
            <el-menu-item index="/cms/youtube/reports">Reports</el-menu-item>
            <el-menu-item index="/cms/youtube/whitelist">Whitelist</el-menu-item>
            <el-menu-item index="/cms/youtube/users">Users</el-menu-item>
            <el-menu-item index="/cms/youtube/keywords">Keywords</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-tooltip effect="dark" content="Logout" placement="bottom">
          <el-menu-item class="float-right" @click.native="logout('admin')">
            <i class="el-icon-d-arrow-right"></i>
          </el-menu-item>
        </el-tooltip>
        <!--<el-menu-item class="float-right" index="/profile">
          Profile
        </el-menu-item>-->
      </el-menu>
    </div>
    <div class="all" v-if="level1">
      <el-menu
        mode="horizontal"
        background-color="#0e0625"
        text-color="#fff"
        active-text-color="#d40c41"
        router
      >
        <el-menu-item index="/">
          <img id="logo" src="@/assets/images/logo.svg" />
        </el-menu-item>
        <el-menu-item index="/">Home</el-menu-item>
        <el-menu-item index="/new-releases">
          Music
        </el-menu-item>
        <el-menu-item index="/reports">Reports</el-menu-item>
        <el-tooltip effect="dark" content="Logout" placement="bottom">
          <el-menu-item class="float-right" @click.native="logout('admin')">
            <i class="el-icon-d-arrow-right"></i>
          </el-menu-item>
        </el-tooltip>
      </el-menu>
    </div>
    <div class="all" v-if="level2">
      <el-menu
        mode="horizontal"
        background-color="#0e0625"
        text-color="#fff"
        active-text-color="#d40c41"
        router
      >
        <el-menu-item index="/">
          <img id="logo" src="@/assets/images/logo.svg" />
        </el-menu-item>
        <el-menu-item index="/">Home</el-menu-item>
        <el-menu-item index="/user">
          Users
        </el-menu-item>
        <el-menu-item index="/new-releases">
          Music
        </el-menu-item>
        <el-menu-item index="/reports">Reports</el-menu-item>
        <el-submenu index="/cms">
          <template slot="title">
            CMS
          </template>
          <el-menu-item index="/cms/affiliate">Affiliate</el-menu-item>
          <el-menu-item index="/cms/pre-approved"
          >Pre-approved channels
          </el-menu-item
          >
          <el-menu-item index="/cms/blog">Blog</el-menu-item>
          <el-menu-item index="/cms/blog-author">Blog Author</el-menu-item>
          <el-submenu index="/cms/carousel">
            <template slot="title">
              Carousel
            </template>
            <el-menu-item index="/cms/carousel/campaign-highlight"
            >Campaign Highlight
            </el-menu-item
            >
            <el-menu-item index="/cms/carousel/community">Community</el-menu-item>
            <el-menu-item index="/cms/carousel/new-releases"
            >Music
            </el-menu-item
            >
            <el-menu-item index="/cms/carousel/opportunities"
            >Opportunities
            </el-menu-item
            >
          </el-submenu>
          <el-menu-item index="/cms/contracts">Contracts</el-menu-item>
          <el-menu-item index="/cms/faq">FAQ</el-menu-item>
          <el-menu-item index="/cms/file-manager">File Manager</el-menu-item>
          <el-menu-item index="/cms/terms">Terms & Conditions</el-menu-item>
          <el-menu-item index="/cms/testimonial">Testimonial</el-menu-item>
          <el-submenu index="/cms/youtube">
            <template slot="title">
              Youtube Content ID
            </template>
            <!--<el-menu-item index="/cms/youtube/assets">Assets</el-menu-item>-->
            <el-menu-item index="/cms/youtube/claims/removal"
            >Claims for removal
            </el-menu-item
            >
            <el-menu-item index="/cms/youtube/claims">Claims</el-menu-item>
            <el-menu-item index="/cms/youtube/licensing">Licensing</el-menu-item>
            <el-menu-item index="/cms/youtube/whitelist">Whitelist</el-menu-item>
            <el-menu-item index="/cms/youtube/users">Users</el-menu-item>
            <el-menu-item index="/cms/youtube/keywords">Keywords</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-tooltip effect="dark" content="Logout" placement="bottom">
          <el-menu-item class="float-right" @click.native="logout('admin')">
            <i class="el-icon-d-arrow-right"></i>
          </el-menu-item>
        </el-tooltip>
      </el-menu>
    </div>
  </el-header>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import store from "../../../plugins/vuex";
export default {
  computed: {

    level1: function() {
      if (store.state.auth.user.permission === 1) return true
      else {
        return false
      }
    },
    level2: function() {
      if (store.state.auth.user.permission === 2) return true
      else {
        return false
      }
    },
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    }
  },
  methods: {
    reloadPage() {
      //location.reload();
    }
  }
}
</script>
